import type { GroupStreamSettingsLocation } from './stream-settings';

/** «Область, город, район, улица, дом» — пустые части опускаются. */
export function buildLocationString(location: GroupStreamSettingsLocation | undefined): string | null {
  const parts = [
    location?.area,
    location?.city,
    location?.district,
    location?.street,
    location?.house_number,
  ].filter((part) => !!part);

  return parts.length > 0 ? parts.join(', ') : null;
}
